import React from 'react';
import type { ChildrenProp } from '../common-types';
import type { BoxLayoutProps } from '../layout';
import { HBox, VBox } from '../layout';

export type CardProps = {
  className?: string;
  boxLayout: 'horizontal' | 'vertical';
  shadow?: 'shadow-1' | 'shadow-2';
} & Required<ChildrenProp> &
  Readonly<BoxLayoutProps>;

export function Card({
  className = '',
  boxLayout,
  children,
  shadow = 'shadow-1',
  ...props
}: Readonly<CardProps>): JSX.Element {
  const cardClassName = ['ehs-card', className, shadow].join(' ');
  return boxLayout === 'horizontal' ? (
    <HBox {...props} className={cardClassName}>
      {children}
    </HBox>
  ) : (
    <VBox {...props} className={cardClassName}>
      {children}
    </VBox>
  );
}
